import cardsFaq from "./cards/_faq.js";

const components = () => {
   cardsFaq();
}
export default components;
